import {
  FC,
  JSX,
  ReactNode
} from "react";
import { View, Text } from "react-native";
import dayjs from "dayjs";
import { DATE_FORMAT } from "@/_utils/formatDate";
import { IRevision } from "@/app/(main)/subscriptionAnalytics";
import Divider from "@/app/components/Divider";
import SuccessIcon from "@/assets/icons/main/greenAlert.svg"

interface IRevisionBlockProps {
  revisions: IRevision[];
  emptyMessage: string
  icon: ReactNode;
}

const RevisionBlockWithDivider: FC<IRevisionBlockProps> = ({
  revisions,
  emptyMessage,
  icon
}): JSX.Element => {

  if (revisions.length === 0) {
    return (
      <View className="flex-1 justify-center items-center">
        {icon || <SuccessIcon />}
        <Text className="text-black text-base mt-2 text-center">{emptyMessage}</Text>
      </View>
    );
  }

  const renderRevision = (item: IRevision, index: number): JSX.Element => {
    const isLast: boolean = index === revisions.length - 1;
    const isSingle: boolean = revisions.length === 1;

    return (
      <View key={index}>
        <Text className="text-base text-gray mb-0.5">
          {item.startDate ? dayjs(item.startDate).format(DATE_FORMAT) : "—"}
        </Text>
        <Text className="text-base text-black">
          {item.organ} {item.title}
        </Text>

        {!isLast && !isSingle && <Divider className="my-5" />}
      </View>
    );
  };

  return (
    <View className="border border-gray-400 p-5 rounded-32px">
      {revisions.map(renderRevision)}
    </View>
  );
};

export default RevisionBlockWithDivider;
